import { Layout } from '@/components/generic';
import { useTranslation } from 'react-i18next';

import ReferralCode from '../Referral/ReferralCode/index';
import CardHolderManager from './CardHolderManager';
import Coupons from './Coupons';
import Delete from './Delete';
import PrivateKey from './PrivateKey';
import ProfileInformation from './ProfileInformation';
import Security from './Security';

export const Settings = () => {
  const { t } = useTranslation();

  return (
    <div className='min-h-screen bg-b-surface1 font-inter text-body-1 text-t-primary antialiased'>
      <Layout title={t('profile.title')}>
        <div className='flex flex-col gap-3 w-full pl-3  max-lg:pl-0'>
          <ProfileInformation />
          <CardHolderManager />
          <Coupons />
          <ReferralCode />
          <div className='grid grid-cols-2 w-full gap-3'>
            <PrivateKey />
            <Security />
          </div>
          <Delete />
        </div>
      </Layout>
    </div>
  );
};
